<template>
    <section class="hb-bab-info px-6">
        <h1 class="hb-title">GIFT COLLECTION</h1>
        <h1 class="product-name">Build A Box</h1>

        <div class="description-wrapper">
            <h2 class="subtitle mb-1" style="font-size: 1.2rem;">{{settings.title}}</h2>
            <p class="mb-1" :class="{'description--hidden': isToggleable && !isToggled}" v-html="settings.body_html">
            </p>
        </div>
        
        <div v-if="isToggleable" @click="isToggled = !isToggled" class="see-more py-3" :class="{'see-more--hidden':!isToggled}">
            {{isToggled? 'Hide' : 'See More'}}
        </div>
    </section>
</template>

<script>
export default {
    name: 'hb-bab-info',
    data(){
        return{
            isToggled: false
        }
    },
    computed:{
        isToggleable(){
            return this.settings?.body_html?.length > 300;
        },
        settings(){
            return this.$store.state.productDetails
        }
    }
}
</script>

<style>

</style>